module.exports = __webpack_public_path__ + "static/media/pengumuman.4f2734ec.svg";